import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import { useSelector } from 'react-redux';
import Form from '../../../common/Form';
import { useForm } from 'react-hook-form';
import { addMilestoneInServiceRequest } from '../../../actions/service_request';
import { actualValueForDropdown, ScogoID } from '../../../utils/common';
import Milestone from '../../../components/Inputs/MileStone';
import { convertIntoPaisa, convertIntoRupee } from '../../../utils/utils';
import { MilestoneType } from '../TicketController';

const formName = 'assign_tech_support';
const fieldName = `milestone`;

export default function AddMilestoneInServiceRequest({ serviceRequest }) {
    const defaultValues = {};
    const dispatch = useDispatch();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const newLoggedUserData = useSelector(state => state.auth.newLoggedUserData);
    console.log(serviceRequest, 'serviceRequest');

    const submit = (formValues) => {
        const payload = {
            title: `Milestone ${serviceRequest.milestones.length + 1}`,
            type: formValues.milestone.label,
            tasks: formValues.milestone.milestone.tasks,
            payments: {
                SP_SERVICE: convertIntoPaisa(formValues[`${fieldName}:SP_SERVICE`]),
                PSP_INCENTIVE: convertIntoPaisa(formValues[`${fieldName}:PSP_INCENTIVE`]),
                CLUSTER_INCENTIVE: convertIntoPaisa(formValues[`${fieldName}:CLUSTER_INCENTIVE`]),
                WAREHOUSE_OWNER_INCENTIVE: convertIntoPaisa(formValues[`${fieldName}:WAREHOUSE_OWNER_INCENTIVE`])
            }
        };

        const isLogistics = formValues.milestone.label === MilestoneType.LOGISTICS;
        if (isLogistics) {
            payload.receive_location_id = actualValueForDropdown(formValues[`${fieldName}:site`]);
            payload.dispatch_location_id = actualValueForDropdown(formValues[`${fieldName}:pickup_site`]);
        }

        const isRma = formValues.milestone.label === MilestoneType.RMA;
        if (isRma) {
            payload.dispatch_location_id = actualValueForDropdown(formValues[`${fieldName}:dispatch_location_id`]);
            payload.receive_location_id = actualValueForDropdown(formValues[`${fieldName}:receive_location_id`]);
            payload.location_id = serviceRequest.location_id;
        }

        if (actualValueForDropdown(formValues[`${fieldName}:asset_id`])) {
            payload.asset_id = actualValueForDropdown(formValues[`${fieldName}:asset_id`]);
        }
        dispatch(addMilestoneInServiceRequest({ ticketId: serviceRequest.id, payload, formName }));
    };

    const methods = useForm({ defaultValues, mode: 'all' });

    const handleMilestoneChange = (value, event) => {
        const findType = serviceRequest.milestones.find((elem) => elem.type === event.milestone.type);

        // if (findType && findType.payments) {
        //     if (parseFloat(findType.payments.SP_SERVICE)) methods.setValue(`${fieldName}:SP_SERVICE`, convertIntoRupee(findType.payments.SP_SERVICE));
        //     if (parseFloat(findType.payments.PSP_INCENTIVE)) methods.setValue(`${fieldName}:PSP_INCENTIVE`, convertIntoRupee(findType.payments.PSP_INCENTIVE));
        //     if (parseFloat(findType.payments.CLUSTER_INCENTIVE)) methods.setValue(`${fieldName}:CLUSTER_INCENTIVE`, convertIntoRupee(findType.payments.CLUSTER_INCENTIVE));
        //     if (parseFloat(findType.payments.WAREHOUSE_OWNER_INCENTIVE)) methods.setValue(`${fieldName}:WAREHOUSE_OWNER_INCENTIVE`, convertIntoRupee(findType.payments.WAREHOUSE_OWNER_INCENTIVE));
        // } else {
        const selectedMilestonePrice = event?.milestone?.price;
        if (!selectedMilestonePrice) {
            methods.setValue(`${fieldName}:SP_SERVICE`, 0);
            methods.setValue(`${fieldName}:PSP_INCENTIVE`, 0);
            methods.setValue(`${fieldName}:CLUSTER_INCENTIVE`, 0);
            methods.setValue(`${fieldName}:WAREHOUSE_OWNER_INCENTIVE`, 0);
            return;
        };
        methods.setValue(`${fieldName}:SP_SERVICE`, convertIntoRupee(selectedMilestonePrice.SP_SERVICE));
        methods.setValue(`${fieldName}:PSP_INCENTIVE`, convertIntoRupee(selectedMilestonePrice.PSP_INCENTIVE));
        methods.setValue(`${fieldName}:CLUSTER_INCENTIVE`, convertIntoRupee(selectedMilestonePrice.CLUSTER_INCENTIVE));
        methods.setValue(`${fieldName}:WAREHOUSE_OWNER_INCENTIVE`, convertIntoRupee(selectedMilestonePrice.WAREHOUSE_OWNER_INCENTIVE));
        // }
    };

    const canEditVendorPricing = useMemo(() => {
        const isSameOrgTicket = newLoggedUserData.orgMemberships.find(({ id }) => id === serviceRequest.helpdesk_id);
        return isSameOrgTicket;
    }, [serviceRequest.helpdesk_id, newLoggedUserData.orgMemberships]);

    const canEditIncentivePricing = useMemo(() => {
        return serviceRequest.helpdesk_id === ScogoID && newLoggedUserData.org.id === ScogoID;
    }, [serviceRequest.helpdesk_id, newLoggedUserData.org.id]);

    return (
        <div>
            <Form
                methods={methods}
                onSubmit={submit}
                buttonPostion={'justify-end'}
                submitButtonText={'Submit'}
                onCancel={() => dispatch(closeModalAction())}
                showSubmit
                submitContainerClassName='flex gap-2 justify-end py-4 px-4'
                isLoading={formButtonLoading[formName]}
            >
                <div className='px-4 py-2 grid grid-cols-3 gap-4'>
                    <Milestone
                        id={'new_milestone'}
                        onChange={handleMilestoneChange}
                        name={`${fieldName}`}
                        label='Milestone'
                        org_id={serviceRequest.org_id}
                        openAddAsset={false}
                        canEditVendorPricing={canEditVendorPricing}
                        canEditIncentivePricing={canEditIncentivePricing}
                    />
                </div>
            </Form>
        </div>
    );
};
